
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop, Watch } from "vue-property-decorator";
    import MediaSupport, { IMediaSupportResult } from "@/utilities/MediaSupport";
    import PhotoCapture from "@/vue/components/PhotoCapture.vue";
    import FileUpload from "@/vue/components/FileUpload.vue";
    import { PhotoCaptureOptions } from "@/model/pagePartOptions/PhotoCaptureOptions";
    import { VisitAnswer } from "@/model/VisitAnswer";
    import { Resource } from "@/model/Resource";

    @Component({components: { PhotoCapture, FileUpload }})
    export default class PhotoCapturePart extends Vue {

        async mounted(): Promise<void> {
            MediaSupport.check((result: IMediaSupportResult) => {
                this.supportsVideoCamera = result.hasWebcam;
            });

            const photoCapture = this.$refs.photoCapture as PhotoCapture;
            photoCapture.showExistingImage(this.answer.photoResource);
        }

        @Watch("answer.resource", { immediate: false }) 
        async onResourceChanged(val: string, old: string) {           
            const photoCapture = this.$refs.photoCapture as PhotoCapture;
            photoCapture.showExistingImage(this.answer.photoResource);
        }

        supportsVideoCamera: boolean = true;

        @Prop({ default: new PhotoCaptureOptions() })
        options!:PhotoCaptureOptions;

        @Prop({ required: true })
        answer!: VisitAnswer;

        @Prop({ default: false })
        isAdminView!: boolean;

        onUploaded(resource: Resource) {
            console.log("PhotoCapturePart onUploaded - ", this.answer.photoResource)
            this.$emit("answer-changed", -1, this.answer?.pagePartID ?? 0, this.answer.photoResource.filename);
        }
    }
